
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNotEmpty',
  pure: false
})
export class IsNotEmptyPipe implements PipeTransform {
  transform(value: any): boolean {
    return !!value;
  }
}
